import { camelCase, words } from 'lodash'
import interactionComponent from './topicInteraction'

const requireModule = require.context('.', false, /\.svg$/) //extract vue files inside modules folder

const components = {}

const capitalise = s => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

const pascalCase = s => capitalise(camelCase(s))

requireModule.keys().forEach(fileName => {
    let componentName = pascalCase(fileName.replace(/(\.\/|\.svg)/g, ''))
    let component = requireModule(fileName).default

    let ws = words(componentName)
    let name = ws.join(' ')

    if (name === 'Speed Iteration') {
        name = 'Speed & Iteration'
    } else if (name === 'Artificial Intelligence') {
        name = 'Operational Artificial Intelligence'
    } else if (name === 'Data Education') {
        name = 'Education & Data Literacy'
    } else if (name === 'Data Ethics') {
        name = 'Data Ethics & Equity'
    } else if (name === 'Hands On') {
        name = 'hands on empowerment'
    } else if (name === 'Data Science') {
        name = 'custom data science'
    } else if (name === 'Interaction Design') {
        name = 'interaction design'
    } else if (name === 'Align Strategy') {
        name = 'strategic alignment'
    }

    let nameMixin = {
        data() {
            return {
                name: name.toLowerCase()
            }
        }
    }

    component.mixins = [interactionComponent, nameMixin]
    components[componentName] = component
})

export default components

const {
    // technology
    InternalData,
    ExternalData,
    BusinessIntelligence,
    DataScience,
    ArtificialIntelligence,
    // strategy
    CustomVisuals,
    AlignStrategy,
    // culture
    DataEducation,
    DataEthics,
    // proto
    SpeedIteration,
    CommercialAlignment,
    // empowerment
    HandsOn,
    PerpetuatingInnovation,
    // policy
    PrivacyPolicy,
    SecurityPolicy
} = components

const technology = {
    InternalData,
    ExternalData,
    BusinessIntelligence,
    DataScience,
    ArtificialIntelligence
}

const strategy = {
    CustomVisuals,
    AlignStrategy
}

const culture = {
    DataEducation,
    DataEthics
}

const prototype = {
    SpeedIteration,
    CommercialAlignment
}

const empowerment = {
    HandsOn,
    PerpetuatingInnovation
}

const policy = {
    PrivacyPolicy,
    SecurityPolicy
}

export { technology, strategy, culture, prototype, empowerment, policy }
